import { HlPercentageTypeEnum } from "@gtpl/shared-models/common-models";
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('hlpercentage')
export class HlPercentage {

  @PrimaryGeneratedColumn("increment",{name:'hlpercentage_id'})
  hlPercentageId:number;

  @Column({
      nullable:false,
      name:"min_grade"
      })
      minGrade:number;
  @Column({
      nullable:false,
      name:"max_grade"
      })
      maxGrade:number;
  @Column({
      type:"decimal",precision:6,scale:2,
      nullable:false,
      name:"hl_percentage"
      })
      hlPercentage:number;

    @Column('enum',{
        name:'type',
        enum:HlPercentageTypeEnum
    })
    type: HlPercentageTypeEnum

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;
  
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      default:1,
      name: "created_user"
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: string | null;


  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;


}
